import {Component, HostBinding, Input, OnDestroy} from '@angular/core';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {RouteLibraryService} from '../../route/route-library.service';
import {HttpClient} from '@angular/common/http';
import {OrderPhotosLightboxService} from '../../layout/order-photos-lightbox/order-photos-lightbox.service';
import * as moment from 'moment';
import {RouteLibraryEntities} from '../../route/route-library-entity';

@Component({
  selector: 'app-unit-last-order-images',
  templateUrl: './unit-last-order-images.component.html',
})

export class UnitLastOrderImagesComponent implements OnDestroy {
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  @HostBinding('class.order-images-container') true;
  @Input() imageGroupsData: Array<any>;
  @Input() latestOrderPhotos: Array<any>;

  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
  };

  constructor(
    public routeLibrary: RouteLibraryService,
    protected http: HttpClient,
    protected orderPhotosLightboxService: OrderPhotosLightboxService,
  ) {
  }

  formatTimestampToDate(timestamp: number) {
    return moment.unix(timestamp).format('DD.MM.YYYY, HH:mm');
  }

  openLightbox(imageId: number) {
    const index = this.latestOrderPhotos.findIndex((el: any) => el.imageId === imageId);
    this.orderPhotosLightboxService.open(this.latestOrderPhotos, index, true, false);
  }

  ngOnDestroy() {
  }
}
